import { app, Component, ojs, payload } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import {
	either,
	eParse,
	isMobile,
	cleanDispose,
	empty,
	formatThousand,
	oneOf,
} from "../../helpers";
import MentionResult from "./MentionResult";
import MentionSearchModal from "./MentionSearchModal";
import MentionSearchCanvas from "./MentionSearchCanvas";
import { routes } from "../../backendRoutes";

const h = app("h");
const gc = app("gc");
const api = app("api");
const broker = app("broker");
const $e = app("$e");

ojs(MentionResult, MentionSearchModal, MentionSearchCanvas);

export default class MentionSearchForm extends Component {
	holder = null;
	timeoutId = null;

	render(config, ...args) {
		return h.div(
			h.div(
				{ class: "input-group mb-3 fs-4" },
				h.div(
					{ class: "input-group-prepend" },
					h.span(
						{
							class: "input-group-text fw-600 fs-4",
						},
						config?.type ?? "@"
					)
				),
				h.input({
					class: "form-control fs-4",
					type: "search",
					placeholder: either(
						config?.type == "@",
						"Find User...",
						"hashtag..."
					),
					msf_hook: "msf-search-input",
					oninput: this.method("findSuggestions", "${this}"),
				})
			),
			h.div({
				class: "mb-3",
				msf_suggestions_holder: "msf-holder",
				from: config?.from,
				hook: config?.hook,
				type: config?.type,
			}),
			...args
		);
	}

	$$mention = {
		needs: {
			searchForm: (ed, event) => this.showForm(ed, event),
		},
	};

	async showForm(ed, event) {
		let { from, hook, type } = eParse(ed).meta;

		if (this.holder) {
			cleanDispose(this.holder);
		}

		if (isMobile()) {
			this.holder = tool.offcanvas(
				h.MentionSearchCanvas(
					h.MentionSearchForm({ from, hook, type })
				),
				{ style: "z-index: 1065; max-height: fit-content;" },
				"top"
			);
		} else {
			this.holder = tool.plainModal(
				h.MentionSearchModal(h.MentionSearchForm({ from, hook, type })),
				{}
			);
		}

		this.holder.show();

		setTimeout(() => {
			dom.get(`[msf-hook="msf-search-input"]`)?.focus();
		}, 1000);

		this.suggest();
	}

	findSuggestions(elem) {
		clearTimeout(this.timeoutId);

		this.timeoutId = setTimeout(() => {
			this.suggest(elem);
		}, 500);
	}

	async suggest(elem) {
		let value = elem?.value || "";
		let holder = dom.get(`[msf-suggestions-holder="msf-holder"]`);

		let spinner = h.Spinner({
			class: "bg-light border-bottom p-2",
			msf_spinner: true,
			parent: holder,
			resetParent: true,
		});

		let type = holder.getAttribute("type");

		let st = type == "@" ? "users" : "tags";

		let res = await api.get(`${routes.mentions}/suggest/${st}`, {
			term: value,
		});

		let from = holder.getAttribute("from");
		let hook = holder.getAttribute("hook");
		let isNew = false;

		if (res) {
			dom.empty(holder);
			let suggestions = res.data.suggestions;

			for (let suggestion of suggestions) {
				if (type == "#" && !empty(value)) {
					isNew = true;
					if (suggestion.name == value) isNew = false;
				}

				h.MentionResult(suggestion, type, {
					parent: holder,
					onclick: this.method("selectSuggestion", [
						type == "@" ? suggestion?.username : suggestion?.name,
						{
							from,
							hook,
							type,
						},
					]),
				});
			}
		}

		if (!res || res.data.suggestions?.length == 0 || isNew) {
			if (type == "@") {
				h.div(
					{ class: "text-secondary text-center p-3", parent: holder },
					"No suggestions found"
				);
			} else if (type == "#") {
				let name = value
					.split(" ")
					.map((word) => {
						if (word.length > 0) {
							return word[0].toUpperCase() + word.slice(1);
						}
						return word;
					})
					.join("");

				h.MentionResult(
					{
						name,
						usage_count: 0,
					},
					type,
					{
						parent: holder,
						onclick: this.method("selectSuggestion", [
							name,
							{
								from,
								hook,
								type,
							},
						]),
					}
				);
			}
		}

		spinner.remove();
	}

	selectSuggestion(value, ed) {
		this.holder?.hide();
		broker.send($e.mention.has.value, payload({ value }, ed));
	}

	cleanUp() {
		super.cleanUp();
		cleanDispose(this.holder);
		this.timeoutId = null;
	}

	closeForm() {
		this.holder.hide();
	}
}

